import React, { Fragment } from "react"
import { appTeamRoundPath } from "../../App/paths"
import { TeamRound } from "../../types"
import { formatScore, thru } from "../../util"

interface TeamLeaderboardProps {
  teamRound: TeamRound
  teamRounds: TeamRound[]
}

export default function TeamLeaderboard({ teamRound, teamRounds }: TeamLeaderboardProps) {
  const startedTeamRounds = []
  const notStartedTeamRounds = []

  for (const tr of teamRounds) {
    if (tr.holesCompleted > 0) {
      startedTeamRounds.push(tr)
    } else {
      notStartedTeamRounds.push(tr)
    }
  }

  return (
    <>
      {startedTeamRounds.length > 0 ? <StartedTeams teamRound={teamRound} teamRounds={startedTeamRounds} /> : null}
      {notStartedTeamRounds.length > 0 ? (
        <NotStartedTeams teamRound={teamRound} teamRounds={notStartedTeamRounds} />
      ) : null}
    </>
  )
}

function teamProfileHref(teamRoundId: number) {
  const backPath = `${window.location.pathname}${window.location.search}`
  return appTeamRoundPath(teamRoundId, { back_path: backPath })
}

function goToTeamProfile(teamRoundId: number) {
  window.location.href = teamProfileHref(teamRoundId)
}

interface StartedTeamsProps {
  teamRound: TeamRound
  teamRounds: TeamRound[]
}

function StartedTeams({ teamRound, teamRounds }: StartedTeamsProps) {
  return (
    <table className="round-scoring-leaderboard" style={{ marginBottom: "2rem" }}>
      <thead>
        <tr>
          <th></th>
          <th>TEAM</th>
          <th className="round-scoring-value">SCORE</th>
          <th className="round-scoring-value">THRU</th>
          <th className="round-scoring-value">PTS</th>
        </tr>
      </thead>
      <tbody>
        {teamRounds.map((tr, i) => {
          const bold = teamRound && tr.id === teamRound.id ? "bold" : "normal"
          return (
            <Fragment key={i}>
              <tr className="team" style={{ cursor: "pointer" }} onClick={() => goToTeamProfile(tr.id)}>
                <td style={{ minWidth: "26px" }}>{tr.position.label}</td>
                <td className="team-name" style={{ fontWeight: bold }}>
                  {tr.name}
                </td>
                <td className="round-scoring-value">{formatScore(tr.netScoreRelativeToPar)}</td>
                <td className="round-scoring-value">{thru(tr.holesCompleted, tr.complete)}</td>
                <td className="round-scoring-value">{tr.position.points}</td>
              </tr>
              <tr className="players" style={{ cursor: "pointer" }} onClick={() => goToTeamProfile(tr.id)}>
                <td></td>
                <td colSpan={4} style={{ fontWeight: bold }}>
                  {tr.players.map((p) => p.user.name).join(" / ")}
                </td>
              </tr>
            </Fragment>
          )
        })}
      </tbody>
    </table>
  )
}

interface NotStartedTeamsProps {
  teamRound: TeamRound
  teamRounds: TeamRound[]
}

function NotStartedTeams({ teamRound, teamRounds }: NotStartedTeamsProps) {
  return (
    <table className="round-scoring-leaderboard" style={{ marginBottom: "2rem" }}>
      <thead>
        <tr>
          <th></th>
          <th>TEAM</th>
          <th className="round-scoring-value">{teamRounds[0].startGroup ? "START HOLE" : "TEE TIME"}</th>
        </tr>
      </thead>
      <tbody>
        {teamRounds.map((tr, i) => {
          const bold = teamRound && tr.id === teamRound.id ? "bold" : "normal"
          return (
            <Fragment key={i}>
              <tr className="team" style={{ cursor: "pointer" }} onClick={() => goToTeamProfile(tr.id)}>
                <td style={{ minWidth: "26px" }}>&nbsp;</td>
                <td className="team-name" style={{ fontWeight: bold }}>
                  {tr.name}
                </td>
                <td className="round-scoring-value">
                  {tr.startGroup ? `${tr.startHoleNumber}${tr.startGroupLabel}` : tr.startTimeOfDay}
                </td>
              </tr>
              <tr className="players" style={{ cursor: "pointer" }} onClick={() => goToTeamProfile(tr.id)}>
                <td></td>
                <td colSpan={2} style={{ fontWeight: bold }}>
                  {tr.players.map((p) => p.user.name).join(" / ")}
                </td>
              </tr>
            </Fragment>
          )
        })}
      </tbody>
    </table>
  )
}
